export default __webpack_public_path__ + "static/sillhouttes-small-77fd50d834198c4e0f00be5d66158921.png";